import { FC, useState } from "react";
import { withProcedureWraper } from "../../../..";
import { Icon } from "../../../../../../components";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Routes } from "../../../../../../AppRoutes";
import { RecallToolProgress } from "../../components/progress";
import { RecallToolInformation, RecallToolList, RecallToolEvalate, RecallToolHistory } from "../../components";
import { CreateNotification } from "../../../../../../components/notifier";
import { PlanningDepartmentRecallToolService } from "../../../../../../services/planning-department/recall-tool";
import { useSelector } from "../../../../../../store/store";
import { EmployeeService } from "../../../../../../services/employee/employee.service";
import { getUCTDate } from "../../../../../../helper/dateTimeHelper";
import { SystemCode, requestStatus } from "../../../../../../constants";
import { useMount } from "ahooks";
import { Form, Input, Modal } from "antd";
import { IToolDetailType } from "../../models";
import { getEnv } from "../../../../../../AppConfigs";
import { StyledButton, StyledTitle } from "../../../../../../components/styled-antd";
import { isEnableEdit } from "../../../../human-organization/summary-employee-request/utils";
import { getApproverName } from "../../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { sendEmail } from "../../../../human-organization/summary-employee-request/utils/send-mail";
import { useSoftwares } from "../../../../../../hook";

export const recallToolDetail: FC = withProcedureWraper(() => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username?.toString().toLowerCase();
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const { getITLeadITHeadAssignee } = useSoftwares();

  const [form] = Form.useForm();

  const siteUrl = getEnv("REACT_APP_APPROVER_RECALL_TOOL_PLANNING_DEPARTMENT");

  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);

  const approveRequest = async () => {
    if ((!inspectionUnit || !evaluation) && getNextStep() === 2) {
      CreateNotification({
        title: "Thông báo",
        body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
        icon: "/icons/warning.png",
      });

      return;
    }

    try {
      if (getNextStep() === 1) {
        if (detail?.fields?.eApprovedBy === currentUserName) {
          // const resp = await PlanningDepartmentRecallToolService.updateRequest(id, {
          //   eApprovedStatus: requestStatus.approved,
          //   eApprovedDate: getUCTDate(),
          //   eRequestStatus: requestStatus.approved,
          //   inspectionUnit,
          //   evaluation,
          //   eApprovalComment: form.getFieldValue("comment") || "",
          // });

          sendEmail(
            detail,
            "ETA",
            `${detail?.fields?.eApprovedByITLead}|${getApproverName(
              detail?.fields?.eApprovedByITLead || "",
              employees,
              softwares,
              getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITLead,
            )}`,
            mailtemplates,
            "",
            siteUrl,
            form.getFieldValue("comment") || "",
            true,
          );
        }
      } else if (getNextStep() === 2) {
        // const resp = await PlanningDepartmentRecallToolService.updateRequest(id, {
        //   eApprovedByITLeadStatus: requestStatus.approved,
        //   eApprovedByITLeadDate: getUCTDate(),
        //   eRequestStatus: requestStatus.approved,
        //   eInspectionUnit: inspectionUnit,
        //   eInspectionUnitComment: evaluation,
        //   eITLeadComment: form.getFieldValue("comment") || "",
        // });

        sendEmail(
          detail,
          "ETA",
          `${detail?.fields?.eApprovedByITHead}|${getApproverName(
            detail?.fields?.eApprovedByITHead || "",
            employees,
            softwares,
            getITLeadITHeadAssignee(SystemCode.ETR).eApprovedByITHead,
          )}`,
          mailtemplates,
          "",
          siteUrl,
          form.getFieldValue("comment") || "",
          true,
        );
      } else if (getNextStep() === 3) {
        // const resp = await PlanningDepartmentRecallToolService.updateRequest(id, {
        //   eApprovedByITHeadStatus: requestStatus.approved,
        //   eApprovedByITHeadDate: getUCTDate(),
        //   eITHeadComment: form.getFieldValue("comment") || "",
        // });

        sendEmail(
          detail,
          "ETA",
          `${detail?.fields?.eAssignee}|${getApproverName(
            detail?.fields?.eAssignee || "",
            employees,
            softwares,
            getITLeadITHeadAssignee(SystemCode.ETR).eAssignee,
          )}`,
          mailtemplates,
          "",
          siteUrl,
          form.getFieldValue("comment") || "",
          true,
        );
      } else if (getNextStep() === 4) {
        // const resp = await PlanningDepartmentRecallToolService.updateRequest(id, {
        //   eAssigneeStatus: requestStatus.approved,
        //   eAssigneeStatusDate: getUCTDate(),
        //   eAssigneeComment: form.getFieldValue("comment") || "",
        //   eRequestStatus: requestStatus.completed,
        // });

        sendEmail(detail, "ETF", "", mailtemplates, "", siteUrl, form.getFieldValue("comment") || "", true);
      }

      CreateNotification({
        title: "Thành công",
        body: `Đồng ý thành công.`,
        icon: "/icons/success.png",
      });

      history.push(Routes.procedureRecallTool.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Duyệt thất bại`,
        icon: "/icons/error.png",
      });

      history.push(Routes.procedureRecallTool.path);
    }
  };

  const isEnableAccept = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return false;
    }

    if (detail?.fields?.eRequestStatus === requestStatus.completed) {
      return false;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 1 &&
      detail?.fields?.eApprovedStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eApprovedByITHead === currentUserName &&
      nextStep === 3 &&
      detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted
    ) {
      return true;
    }

    if (
      detail?.fields?.eAssignee === currentUserName &&
      nextStep === 4 &&
      detail?.fields?.eAssigneeStatus === requestStatus.submitted
    ) {
      return true;
    }

    return false;
  };

  const isEnableRevoke = () => {
    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return false;
    }

    if (detail?.fields?.eRequestStatus === requestStatus.completed) {
      return false;
    }

    const currentStep = getRevokeStep();

    if (currentStep === 1 && detail?.fields?.eApprovedBy === currentUserName) {
      return true;
    }

    if (currentStep === 2 && detail?.fields?.eApprovedByITLead === currentUserName) {
      return true;
    }

    if (currentStep === 3 && detail?.fields?.eApprovedByITHead === currentUserName) {
      return true;
    }

    return false;
  };

  const rejectRequest = async () => {
    try {
      if (getNextStep() === 1) {
        if (detail?.fields?.eApprovedBy === currentUserName) {
          await PlanningDepartmentRecallToolService.updateRequest(id, {
            eApprovedStatus: "Rejected",
            eApprovedDate: getUCTDate(),
            eRequestStatus: "Rejected",
            eApprovalComment: form.getFieldValue("comment") || "",
          });
        }
      } else if (getNextStep() === 2) {
        await PlanningDepartmentRecallToolService.updateRequest(id, {
          eApprovedByITLeadStatus: "Rejected",
          eApprovedByITLeadDate: getUCTDate(),
          eRequestStatus: "Rejected",
          eITLeadComment: form.getFieldValue("comment") || "",
        });
      } else if (getNextStep() === 3) {
        await PlanningDepartmentRecallToolService.updateRequest(id, {
          eApprovedByITHeadStatus: "Rejected",
          eApprovedByITHeadDate: getUCTDate(),
          eRequestStatus: "Rejected",
          eITHeadComment: form.getFieldValue("comment") || "",
        });
      } else if (getNextStep() === 4) {
        await PlanningDepartmentRecallToolService.updateRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eAssigneeStatus: requestStatus.rejected,
          eAssigneeStatusDate: getUCTDate(),
          eAssigneeComment: form.getFieldValue("comment") || "",
        });
      }

      CreateNotification({
        title: "Thành công",
        body: `Từ chối thành công.`,
        icon: "/icons/success.png",
      });

      sendEmail(detail, "ETR", "", mailtemplates, "", siteUrl, "", true);

      history.push(Routes.procedureRecallTool.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Từ chối thất bại`,
        icon: "/icons/error.png",
      });

      history.push(Routes.procedureRecallTool.path);
    }
  };

  const revokeApproval = async () => {
    const currentStep = getRevokeStep();
    try {
      if (currentStep === 1) {
        await PlanningDepartmentRecallToolService.updateRequest(id, {
          eApprovedStatus: requestStatus.submitted,
          eRequestStatus: requestStatus.submitted,
        });
      }
      if (currentStep === 2) {
        await PlanningDepartmentRecallToolService.updateRequest(id, {
          eApprovedByITLeadStatus: requestStatus.submitted,
          eRequestStatus: requestStatus.submitted,
        });
      }
      if (currentStep === 3) {
        await PlanningDepartmentRecallToolService.updateRequest(id, {
          eRequestStatus: requestStatus.rejected,
          eApprovedByITHeadStatus: requestStatus.rejected,
          eApprovedByITHeadDate: getUCTDate(),
          eITHeadComment: form.getFieldValue("comment") || "",
        });
      }

      CreateNotification({
        title: "Thành công",
        body: `Thu hồi thành công.`,
        icon: "/icons/success.png",
      });

      history.push(Routes.procedureRecallTool.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Thu hồi thất bại`,
        icon: "/icons/error.png",
      });

      history.push(Routes.procedureRecallTool.path);
    }
  };

  const getRevokeStep = () => {
    const nextStep = getNextStep();

    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return 0;
    }

    if (
      detail?.fields?.eApprovedBy === currentUserName &&
      nextStep === 2 &&
      detail?.fields?.eApprovedStatus === requestStatus.approved
    ) {
      return 1;
    }

    if (
      detail?.fields?.eApprovedByITLead === currentUserName &&
      nextStep === 3 &&
      detail?.fields?.eApprovedByITLeadStatus === requestStatus.approved
    ) {
      return 2;
    }

    if (
      detail?.fields?.eApprovedByITHead === currentUserName &&
      nextStep === 4 &&
      detail?.fields?.eApprovedByITHeadStatus === requestStatus.approved
    ) {
      return 3;
    }

    return 0;
  };

  const { id } = useRouteMatch().params as any;

  const [employees, setEmployees] = useState<any[]>([]);
  const [detail, setDetail] = useState<IToolDetailType>({});

  const getEmployees = async () => {
    const employees = await EmployeeService.getEmployees();
    setEmployees(employees);
  };

  const getDetail = async () => {
    const detail = await PlanningDepartmentRecallToolService.getDetail(id);
    setDetail(detail);
    setInspectionUnit(detail?.fields?.eInspectionUnit);
    setEvaluation(detail?.fields?.eInspectionUnitComment);
  };

  const getNextStep = () => {
    if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
      return -1;
    }

    if (detail?.fields?.eApprovedStatus === requestStatus.submitted) {
      return 1;
    }

    if (detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted) {
      return 2;
    }

    if (detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted) {
      return 3;
    }

    if (detail?.fields?.eAssigneeStatus === requestStatus.submitted) {
      return 4;
    }

    return 5;
  };

  useMount(() => {
    getEmployees();
    getDetail();
  });

  const [inspectionUnit, setInspectionUnit] = useState("");
  const [evaluation, setEvaluation] = useState("");

  const showRejectConfirm = () => {
    Modal.confirm({
      title: <StyledTitle level={5}>Thông báo</StyledTitle>,
      content: (
        <>
          Bạn có chắc chắn muốn từ chối yêu cầu này ?
          <br />
          Vui lòng nhập lý do từ chối
          <br />
          <StyledTitle level={5}>
            Lý do <span className="text-danger ml-1">*</span>{" "}
          </StyledTitle>
          <Input
            onChange={(e: any) => {
              form.setFieldValue("comment", e.target.value);
            }}
          />
        </>
      ),
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      cancelButtonProps: {
        style: { backgroundColor: "orange", color: "white" },
      },

      onOk() {
        rejectRequest();
      },
      onCancel() {
        form.setFieldValue("comment", null);
      },
    });
  };

  return (
    <div className="ItCodeGrantedDetailPage pd15">
      <div className="PageHead">
        <div className="title">
          <div className="btnBack" onClick={() => history.push(Routes.procedureRecallTool.path)}>
            <Icon.ArrowLeft />
          </div>
          Xem Xét Yêu Cầu Duyệt
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12">
          <RecallToolProgress employees={employees} detail={detail} />
          <RecallToolInformation detail={detail} />
          <RecallToolList detail={detail} />
          <RecallToolEvalate
            detail={detail}
            setInspectionUnit={setInspectionUnit}
            inspectionUnit={inspectionUnit}
            setEvaluation={setEvaluation}
            evaluation={evaluation}
            getNextStep={getNextStep()}
          />
          <RecallToolHistory detail={detail} employees={employees} form={form} isEnableAccept={isEnableAccept()} />

          <div className="d-flex justify-content-center">
            {isEnableAccept() && (
              <StyledButton bgColor="green" className="mr-3" type="primary" onClick={approveRequest}>
                Đồng ý
              </StyledButton>
            )}

            {isEnableAccept() && (
              <StyledButton bgColor="grey" className="mr-3" onClick={showRejectConfirm} type="primary" danger>
                Không đồng ý
              </StyledButton>
            )}

            {!isEnableAccept() && isEnableRevoke() && (
              <StyledButton bgColor="grey" type="primary" danger className="mr-3" onClick={revokeApproval}>
                Thu hồi
              </StyledButton>
            )}

            {isEnableEdit(getNextStep(), detail, currentUserName) && (
              <StyledButton bgColor="orange" onClick={() => history.push(Routes.createRecall.path.replace(":id", id))}>
                Chỉnh sửa
              </StyledButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});
